import { useEditorStore } from '../../stores/editorStore';

export default function FileActions() {
  const { levelId, loadLevel, save, isLoading } = useEditorStore();

  return (
    <div className="toolbar-group">
      <button
        className="toolbar-button"
        onClick={() => loadLevel('level1')}
        disabled={isLoading}
        title="Abrir editor de Level 1"
      >
        Level 1
      </button>

      <button
        className="toolbar-button"
        onClick={() => loadLevel('level2')}
        disabled={isLoading}
        title="Abrir editor de Level 2"
      >
        Level 2
      </button>

      <select
        className="toolbar-select"
        value={levelId ?? ''}
        disabled={isLoading}
        onChange={(e) => {
          if (e.target.value) {
            loadLevel(e.target.value);
          }
        }}
      >
        <option value="">Select Level...</option>
        {[1, 2, 3, 4, 5, 6, 7].map((num) => (
          <option key={num} value={`level${num}`}>
            Level {num}
          </option>
        ))}
      </select>

      <button
        className="toolbar-button"
        onClick={() => {
          if (levelId) {
            loadLevel(levelId);
          }
        }}
        disabled={!levelId || isLoading}
        title="Reload current level"
      >
        Reload
      </button>

      <button
        className="toolbar-button"
        onClick={save}
        disabled={!levelId || isLoading}
        title="Save (Ctrl+S)"
      >
        Export
      </button>
    </div>
  );
}
